import { render } from "./rectorStudioHome.vue?vue&type=template&id=3d606e3c&scoped=true"
import script from "./rectorStudioHome.vue?vue&type=script&lang=js"
export * from "./rectorStudioHome.vue?vue&type=script&lang=js"

import "./rectorStudioHome.vue?vue&type=style&index=0&id=3d606e3c&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d606e3c"]])

export default __exports__